<div class="container">
  <div class="header">
    <h2>New Block</h2>
  </div>
  <div class="body">
    <ichannel-input
      [placeholder]="'Type block name here...'"
      [direction]="'row'"
      [(value)]="name"
      (onEnterClicked)="create()"
    ></ichannel-input>
  </div>
  <div class="footer">
    <button class="btn cancel" (click)="cancel()">Cancel</button>
    <button class="btn create" (click)="create()">Create</button>
  </div>
</div>
